import { useEventMenu } from "@hooks"
import { Button } from "@heroui/react"
import { Cog6ToothIcon } from "@heroicons/react/24/outline"
import PropTypes from "prop-types"

const EventMenu = ({ event, user, view = "MENU" }) => {
  const { open } = useEventMenu(user, event)

  const handleShowEventViews = () => {
    open(view)
  }

  return (
    <div>
      <Button variant="bordered" className="border-white" isIconOnly onPress={handleShowEventViews}>
        <Cog6ToothIcon className="text-white w-7 h-7" />
      </Button>
    </div>
  )
}

EventMenu.propTypes = {
  event: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  view: PropTypes.string,
}

export default EventMenu